import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioAdminLoginResponse } from '../../../services/responses/usuario-admin/usuario-admin-login.response';
import { AuthService } from '../../../services/apis/usuario-admin/auth.service';
import { ModuloEnum } from '../../../enums/modulo.enum';

@Component({
  selector: 'app-action-nav',
  imports: [CommonModule, RouterModule],
  templateUrl: './action-nav.component.html',
  styleUrl: './action-nav.component.css',
})
export class ActionNavComponent implements OnInit {
  @Input() showActionNav: boolean;
  @Input() moduloEnum: ModuloEnum;
  @Output() showActionNavFalse = new EventEmitter<number>();

  public _usuarioLoginResponse: UsuarioAdminLoginResponse;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this._usuarioLoginResponse = this.authService.getUserInfos();
  }

  clickContainerOut(): void {
    this.showActionNavFalse.emit();
  }
}
